const base = '/landing';

export const landingMedia = {
  heroVideos: [`${base}/hero-1.mp4`, `${base}/hero-2.mp4`],
  steps: {
    create: `${base}/step-create.webp`,
    launch: `${base}/step-launch.webp`,
    grow: `${base}/step-grow.webp`,
  },
  say: [
    { poster: `${base}/say-1.webp`, video: `${base}/say-1.mp4` },
    { poster: `${base}/say-2.webp`, video: `${base}/say-2.mp4` },
  ],
  deviceScreen: `${base}/device-screen.webp`,
  stores: {
    appStore: `${base}/store-app-store.png`,
    googlePlay: `${base}/store-google-play.png`,
    steam: `${base}/store-steam.png`,
  },
  features: {
    monetization: `${base}/feature-monetization.webp`,
    analytics: `${base}/feature-analytics.webp`,
    players: `${base}/feature-players.webp`,
    liveops: `${base}/feature-liveops.webp`,
    monitoring: `${base}/feature-monitoring.webp`,
    agents: `${base}/feature-agents.webp`,
  },
  agents: { poster: `${base}/agents.webp`, video: `${base}/agents.mp4` },
  community: `${base}/community.webp`,
  logo: '/logo.png',
};
